export const UPDATE_PRODUCT_CATEGORY_REQUEST = 'product-category/UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = 'product-category/UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_CATEGORY_FAILURE = 'product-category/UPDATE_PRODUCT_FAILURE';


// WEBPACK FOOTER //
// ./src/modules/product-category/product-category.actionTypes.js